import Vue from 'vue';
import Vuex from 'vuex';
import {getUserInfo} from "@/api/home/index"
import mod_product from "./modules/mod_product"
import {getAction,logout,getParameterToken} from "@/api/user"
import { getShopCarList} from "@/api/shopCar/index"
import { getUserMsgNum} from "@/api/message/index"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    status: '',
    // user: {},

    token: sessionStorage.getItem('Access-Token') || '',
    username: '',
    realname: '',
    welcome: '',
    avatar: '',
    info: {},
    shopTotal:0,
    messageTotal:0,
    user: sessionStorage.getItem('userInfo')||{},
  },
  modules:{
    mod_product:mod_product
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state,user) {
      state.status = 'success';
      state.user = user;
    },
    auth_error(state) {
      state.status = 'error';
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { username, realname, welcome }) => {
      state.username = username
      state.realname = realname
      state.welcome = welcome
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_logout:(state)=>{
      state.token = ''
      state.info = {}
      state.user = {}
    },
    SET_shoptotal:(state,num) =>{
      state.shopTotal = parseInt(num)
    },
    SET_messagetotal:(state,num) =>{
      state.messageTotal = parseInt(num)
    }
  },
  actions: {
    // CAS验证登录
    ValidateLogin({ commit,dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        getAction("service/security-service/sys/cas/client/validateLogin",userInfo).then(response => {
          console.log("----cas 登录--------",response);
          if(response.success){
            const result = response.data
            const userInfoS = result.userInfo
            sessionStorage.setItem('userInfo', JSON.stringify(userInfoS))
            // 每次请求接口时，需要在headers添加对应的Token验证
            // 更新token
            commit('auth_success',userInfoS)
            sessionStorage.setItem('Access-Token', JSON.stringify(result.token))
            // Vue.ls.set('Access-Token', result.token, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            dispatch('getShopTotal')
            dispatch('getMessageTotal')
            resolve(response)
          }else{
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    parameterLogin({commit},parameter){
      return new Promise((resolve, reject) => {
        getParameterToken({token:parameter}).then(response => {
          if(response.success){
            const result = response.data
            const userInfoS = result.userInfo
            sessionStorage.setItem('userInfo', JSON.stringify(userInfoS))
            commit('auth_success',userInfoS)
            sessionStorage.setItem('Access-Token', JSON.stringify(result.token))
            commit('SET_TOKEN', result.token)
            // dispatch('getShopTotal')
            // dispatch('getMessageTotal')
            resolve(response)
          }else{
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUserInfo_ac({commit}) {
      return new Promise((resolve, reject) => {
      commit('auth_request')
      // 向后端发送请求，验证用户名密码是否正确，请求成功接收后端返回的token值，利用commit修改store的state属性，并将token存放在localStorage中
      getUserInfo()
        .then(resp => {
          const user = resp.data
          sessionStorage.setItem('userInfo', JSON.stringify(resp.data))
          // 每次请求接口时，需要在headers添加对应的Token验证
          // 更新token
          commit('auth_success',user)
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          sessionStorage.removeItem('userInfo')
          reject(err)
        })
      })
    },
    LogOut({ commit}){
      return new Promise((resolve, reject) => {
        logout()
        .then(resp => {
          sessionStorage.removeItem('userInfo')
          sessionStorage.removeItem('Access-Token')
          // 每次请求接口时，需要在headers添加对应的Token验证
          // 更新token
          commit('SET_logout')
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          reject(err)
        })
      })
    },
    getShopTotal({commit}){
      return new Promise((resolve, reject) => {
        let parmas = {
          productName:'',
          fileName:'',
          carType:'',
          creationdStartDate:'',
          creationdEndDate:'',
          page:1,
          limit:20
        }
        delete parmas.date
        getShopCarList(parmas)
        .then(resp => {
          let {data} = resp
          if(data){
            commit('SET_shoptotal',data.totalCount)
          }
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          reject(err)
        })
      })
    },
    getMessageTotal({commit}){
      return new Promise((resolve, reject) => {
        getUserMsgNum()
        .then(resp => {
          let {data} = resp
          if(data){
            commit('SET_messagetotal',data)
          }
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          reject(err)
        })
      })
    }
  },
  getters: {
    // !!将state.token强制转换为布尔值，若state.token存在且不为空(已登录)则返回true，反之返回false
    authStatus: state => state.status,
    userInfo_getter : state => {
      let typeUser = state.user
      if(Object.prototype.toString.call(state.user)=='[object String]'){
        typeUser = JSON.parse(state.user)
      }
      return typeUser
    },
    token_getter : state => state.token,
    shopTotal_getter: state => state.shopTotal,
    messageTotal_getter: state => state.messageTotal,
  }
});

export default store;